export const allItems = [
    { _id: 102, title: "Automotive" },
    { _id: 103, title: "Baby" },
    { _id: 104, title: "Beauty & Personal Care" },
    { _id: 105, title: "Books" },
    { _id: 106, title: "Boys' Fashion" },
    { _id: 107, title: "Computers" },
    { _id: 108, title: "Deals" },
    { _id: 109, title: "Digital Music" },
    { _id: 110, title: "Electronics" },
    { _id: 111, title: "Girls' Fashion" },
    { _id: 112, title: "Health & Household" },
    { _id: 113, title: "Home & Kitchen" },
    { _id: 114, title: "Industrial & Scientific" },
    { _id: 115, title: "Kindle Store" },
    { _id: 116, title: "Luggage" },
    { _id: 117, title: "Men's Fashion" },
    { _id: 118, title: "Movies & TV" },
    { _id: 119, title: "Music, CDs & Vinyl" },
    { _id: 120, title: "Pet Supplies" },
    { _id: 121, title: "Prime Video" },
    { _id: 122, title: "Software" },
    { _id: 123, title: "Sports & Outdoors" },
    { _id: 124, title: "Tools & Home Improvement" },
    { _id: 125, title: "Toys & Games" },
    { _id: 126, title: "Video Games" },
    { _id: 127, title: "Women's Fashion" },
  ];
  export const middleList = [
    {
      _id: 2221,
      title: "Get to Know Us",
      listItem: [
        {
          _id: "001",
          listData: [
            "Careers",
            "Blog",
            "About Amazon",
            "Investor Relations",
            "Amazon Devices",
            "Amazon Science",
          ],
        },
      ],
    },
    {
      _id: 2222,
      title: "Make Money with Us",
      listItem: [
        {
          _id: "002",
          listData: [
            "Sell products on Amazon",
            "Sell on Amazon Business",
            "Sell apps on Amazon",
            "Become an Affiliate",
            "Advertise Your Products",
            "Sell Product with Us",
            "Host an Amazon Hub",
            "See More Make Money with Us",
          ],
        },
      ],
    },
    {
      _id: 2223,
      title: "Amazon Payment Products",
      listItem: [
        {
          _id: "003",
          listData: [
            "Amazon Business Card",
            "Shop with Points",
            "Reload Your Balance",
            "Amazon Currency Converter",
          ],
        },
      ],
    },
    {
      _id: 2224,
      title: "Let Us Help You",
      listItem: [
        {
          _id: "004",
          listData: [
            "Amazon and COVID-19",
            "Your Account",
            "Your Orders",
            "Shipping Rates & Policies",
            "Returns & Replacements",
            "Manage Your Content and Devices",
            "Amazon Assistant",
            "FAQ & Help",
          ],
        },
      ],
    },
  ];
  export const footerBottomItem = [
    {
      _id: 1001,
      title: "Amazon Music",
      des: "Stream millions of songs",
    },
    {
      _id: 1002,
      title: "	Amazon Advertising",
      des: "Find, attract, and engage customers",
    },
    {
      _id: 1003,
      title: "Amazon Drive",
      des: "Cloud storage from Amazon",
    },
    {
      _id: 1004,
      title: "6pm",
      des: "Score deals on fashion brands",
    },
    {
      _id: 1005,
      title: "AbeBooks",
      des: "Books, art & collectibles",
    },
    {
      _id: 1006,
      title: "ACX",
      des: "Audiobook Publishing Made Easy",
    },
    {
      _id: 1007,
      title: "Sell on Amazon",
      des: "Start a Selling Account",
    },
    {
      _id: 1008,
      title: "Amazon Business",
      des: "Everything For Your Business",
    },
    {
      _id: 1009,
      title: "AmazonGlobal",
      des: "Ship Orders Internationally",
    },
    {
      _id: 1010,
      title: "Home Services",
      des: "Experienced Pros appiness Guarantee",
    },
    {
      _id: 1011,
      title: "Amazon Ignite",
      des: "Sell your original Digital Educational Resources",
    },
    {
      _id: 1012,
      title: "Amazon Web Services",
      des: "Scalable Cloud Computing Services",
    },
    {
      _id: 1013,
      title: "Audible",
      des: "Listen to Books & Original Audio Performances",
    },
    {
      _id: 1014,
      title: "Book Depository",
      des: "Books With Free Delivery Worldwide",
    },
    {
      _id: 1015,
      title: "Box Office Mojo",
      des: "Find Movie Box Office Data",
    },
    {
      _id: 1016,
      title: "ComiXology",
      des: "Thousands of Digital Comics",
    },
    {
      _id: 1017,
      title: "DPReview",
      des: "Digital Photography",
    },
    {
      _id: 1018,
      title: "Fabric",
      des: "Sewing, Quilting & Knitting",
    },
    {
      _id: 1019,
      title: "Goodreads",
      des: "Book reviews & recommendations",
    },
    {
      _id: 1020,
      title: "IMDb",
      des: "Movies, TV & Celebrities",
    },
    {
      _id: 1021,
      title: "	IMDbPro",
      des: "Get Info Entertainment Professionals Need",
    },
    {
      _id: 1022,
      title: "Kindle Direct Publishing",
      des: "Indie Digital & Print Publishing Made Easy",
    },
    {
      _id: 1023,
      title: "Prime Video Direct",
      des: "Video Distribution Made Easy",
    },
    {
      _id: 1024,
      title: "Shopbop",
      des: "Designer Fashion Brands",
    },
    {
      _id: 1025,
      title: "Woot!",
      des: "Deals and Shenanigans",
    },
    {
      _id: 1026,
      title: "Zappos",
      des: "Shoes & Clothing",
    },
    {
      _id: 1027,
      title: "Ring",
      des: "Smart Home Security Systems",
    },
    {
      _id: 1028,
      title: "eero WiFi",
      des: "Stream 4K Video in Every Room",
    },
    {
      _id: 1029,
      title: "Blink",
      des: "Smart Security for Every Home",
    },
    {
      _id: 1030,
      title: "Neighbors App",
      des: "Real-Time Crime & Safety Alerts",
    },
    {
      _id: 1031,
      title: "Amazon Subscription Boxes",
      des: "Top subscription boxes - right to your doo",
    },
    {
      _id: 1032,
      title: "PillPack",
      des: "Pharmacy Simplified",
    },
  ];